"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateRangeFilter = void 0;
const __1 = require("..");
// NOTE: ラップしてるだけなのでテストは書いてない
const dateRangeFilter = (availablePeriods, dateRangePeriod) => {
    // isSubSetofを使うと末端を跨ぐ空き時刻が省かれてしまうため、Andを使うようにしている。
    return availablePeriods.and(new __1.Periods([dateRangePeriod]));
};
exports.dateRangeFilter = dateRangeFilter;
//# sourceMappingURL=dateRangeFIlter.js.map